const adminMode = process.env.VUE_APP_ADMIN_MODE === 'true';
const hideExtras = adminMode;

function filterEnabled(items) {
  return items.filter((i) => !i.disabled);
}

const allItems = [
  {
    title: 'Launchpad',
    route: 'launchpad',
    icon: 'GridIcon',
    disabled: hideExtras,
  },
  {
    title: 'Dashboards',
    icon: 'TrelloIcon',
    disabled: hideExtras,
    children: [
      {
        title: 'Infrastructure',
        route: 'infra',
        icon: 'CircleIcon',
      },
      {
        title: 'Applications',
        route: 'apps',
        icon: 'CircleIcon',
      },
      {
        title: 'Security',
        route: 'security',
        icon: 'CircleIcon',
      },
      {
        title: 'Custom (Beta)',
        route: 'dashboards',
        icon: 'CircleIcon',
      },
    ],
  },
  {
    title: 'Reports',
    route: 'reports',
    icon: 'FileTextIcon',
    disabled: hideExtras,
  },
  {
    title: 'Data Export',
    route: 'data-export',
    icon: 'DownloadIcon',
    disabled: hideExtras,
  },
  {
    title: 'Agents',
    route: 'agents',
    icon: 'LayersIcon',
  },
  {
    title: 'Integrations',
    route: 'integrations',
    icon: 'GitPullRequestIcon',
  },
  {
    title: 'Policy Center',
    route: 'policy',
    icon: 'ServerIcon',
  },
  {
    title: 'Settings',
    route: 'settings',
    icon: 'SettingsIcon',
  },
  {
    title: 'Knowledge Base',
    route: 'knowledge base',
    icon: 'BookOpenIcon',
    disabled: hideExtras,
  },
];

export default filterEnabled(allItems);
